<template>

    <div>
        <router-view></router-view>

        <div class="pt-3 pb-5">
            <data-table ref="municipalities"
                        :api-route="backendApiRoute"
                        :api-view-set="table.apiViewSet"
                        :name="table.name"
                        :columns="table.columns"
                        :search="table.search"
                        :filters="table.filters ? table.filters : []"
                        :actions="table.actions"
                        :orderings="table.orderings"
                        :initial-orderings="table.initialOrderings"
                        :initial-filters="initialFilters"
                        :row-actions="table.rowActions"
                        :key="table.key"
                        :destroy-title="'Удаление организации'">
            </data-table>
        </div>
    </div>
</template>

<script>
import DataTable from "@/components/Table/DataTable";
import {mapGetters} from "vuex";
import api from "@/api";
import actions from "@/components/Table/actions";
import {Breed} from "@/pages/AppPages/Catalogs/Animals/breed";
import {Organization} from "@/pages/AppPages/Catalogs/Organizations/organization";

export default {
    name: "OrganizationList",
    components: { DataTable },
    props: {
        // initialGroups: { type: Array },
        // creationGroups: { type: Array, default: () => { return [ 'iogv_user' ] } },
        // createRoute: { type: String },
        // detailRoute: { type: String }
    },
    computed: {
        ...mapGetters(['ability', 'isSuperuser']),
        backendApiRoute() { return api.organizations.default.list() },
        initialFilters() {
            return {
                // groups: this.initialGroups
            }
        },
        canCreate() {
            if (this.isSuperuser) return true;
            return this.ability.can('create', 'Organization')
        },
    },
    data() {

        return {
            table: {
                name: 'org-table',
                apiViewSet: api.organizations.default,
                key: 'org-table',
                search: true,
                columns: [
                    {
                        name: 'name',
                        title:  'Название',
                        alwaysVisible: true,
                        to: {
                            idColumn: 'id',
                            routeName: 'organizationDetail',
                            prependWithN: false
                        },
                        extraDataFrom: 'groups_text',
                    },
                    { name: 'activity', title: 'Деятельность',
                        extraDataFrom: 'activity_objects',
                        extraRaw: true,
                        cellComponentName: 'OrganizationActivityCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'municipality', title: 'Муниципалитеты',
                        extraDataFrom: 'municipality_objects',
                        extraRaw: true,
                        cellComponentName: 'OrganizationMunicipalityCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'inn', title: 'ИНН' },
                    { name: 'ogrn', title: 'ОГРН' },
                    { name: 'address_object.short_text', title: 'Адрес' },
                    { name: 'phone', title: 'Телефон' },
                ],
                orderings: [
                    'name',
                ],
                actions: [],
                rowActions: [],
                filters: [
                    { title: 'Муниципалитеты', name: 'municipality', label: 'municipality', labelKey: 'short_name',
                            source: api.municipalities.default.list(), hasSearch: true },
                    { title: 'Вид деятельности', name: 'activities', label: 'activity',
                            source: api.organizations.activities.list() },
                ]
            }
        }
    },
    mounted() {
        if (this.canCreate) {
            this.table.actions.push(
                actions.create(() => {
                        this.$router.push({name: 'organizationCreate'})
                    }, this.canCreate
                )
            );
        }

        if (this.ability.can('destroy', 'Organization')) {
            this.table.rowActions.push(
                new actions.objectDelete(Organization))
        }
    }
}
</script>

<style scoped>

</style>